<template>
  <div>
    {{ $t('message.loading') }}
  </div>
</template>

<script>
import project from '@/project'
const jwt = require('jsonwebtoken')

export default {
  name: 'LoginWithLine',
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'callback')
  },
  created: async function () {
    let isOpenDirectly = opener === null || opener === undefined

    if (isOpenDirectly) {
      window.location = project.config.web.app
    } else {
      var err = false,
        res = null

      if (this.$route.query.token === undefined) {
        err = true
      } else {
        let decoded = jwt.verify(this.$route.query.token, project.config.token.secret)

        let dataSet = {
          'line_id': decoded.line_id,
          'displayname': decoded.displayname,
          'picture': decoded.picture,
        }

        let responseLoginLine = await this.$store.dispatch('LoginLine', dataSet)

        if (responseLoginLine.success === false) {
          err = true
        } else {
          // values in res: app_id, channel, token
          res = this.$route.query
        }
      }

      opener.handleResponse(err, res)
      window.close()
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/callback/LoginWithLine.vue